const Button = {
  state: {},

  getInstance(id) {
    const elem = document.querySelector(`[data-loading="${id}"]`);
    return elem;
  },

  toggleLoading(id) {
    Button.state[id] = true;

    Button.getInstance(id).setAttribute('disabled', 'disabled');
    Button.getInstance(id).classList.add('is-loading');
  },

  reset(id) {
    Button.state[id] = false;

    Button.getInstance(id).removeAttribute('disabled');
    Button.getInstance(id).classList.remove('is-loading');
  }
};

export default Button;
